import { internalFetch } from '../utils/fetchHelper';

export interface IReport {
  type: string;
  title: string;
  source: string;
}

export interface ICreateReportRequest {
  type: string;
  title: string;
  source: string;
}

export interface ICreateReportResponse {
  reportId: number;
}

export interface IUpdateReportRequest {
  type: string;
  title: string;
  source: string;
}

export const getReports = async (
  abortController: AbortController
): Promise<IReport[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/reports?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getReport = async (
  abortController: AbortController,
  reportId?: number
): Promise<IReport> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/reportById?reportId=${reportId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const createReport = async (
  abortController: AbortController,
  data: ICreateReportRequest
): Promise<ICreateReportResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/report`,
    'POST',
    abortController,
    JSON.stringify(data)
  );
};

export const editReport = async (
  abortController: AbortController,
  reportId: number,
  report: IUpdateReportRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/reportById?reportId=${reportId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(report)
  );
};

export const deleteReport = async (
  abortController: AbortController,
  reportId: number
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/reportById?reportId=${reportId}`,
    'DELETE',
    abortController
  );
};
